import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "components/FormField";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect, useState } from "react";
import { Box, LinearProgress, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";
import { useAuthContext } from "context/AuthContext";

const payload = {
  phone: "",
  contact_type: 1,
  contact: "",
}

export default function CooperatedContactsFourth() {
  const [cooperated, setCooperated] = useState(payload);
  const [contactType, setContactType] = useState(1);
  const [inputValueContactType, setInputValueContactType] = useState('');

  const [loading, setLoading] = useState(false);

  const optionsContact = ["Whatsapp", "Ligação", "Presencial", "E-mail"];

  const { uuid } = useParams();
  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true)

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setContactType(response.data.contact_type);

          setCooperated(response.data);

          setLoading(false)
        }
      } catch (e) {
        toast.error(e.response.data)
      }
    })()
    // eslint-disable-next-line
  }, [uuid])

  const contactTypeString = (cntt) => {
    switch (cntt) {
      case 1:
        return "Whatsapp";
      case 2:
        return "Ligação";
      case 3:
        return "Presencial";
      case 4:
        return "E-mail";
      default:
        return cntt;
    }
  }

  const contactTypeNumber = (cntt) => {
    switch (cntt) {
      case "Whatsapp":
        return 1;
      case "Ligação":
        return 2;
      case "Presencial":
        return 3;
      case "E-mail":
        return 4;
      default:
        return cntt;
    }
  }

  const setInput = (event) => {
    const { name, value } = event.target;

    const newCooperated = {
      ...cooperated,
      [name]: value,
    };

    setCooperated(newCooperated);
  };

  const handleNext = async () => {
    try {
      if (user.profile !== 99) {
        const data = {
          ...cooperated,
          contact_type: contactTypeNumber(contactType),
          step: 4
        }

        if (
          !data.birth_date ||
          !data.phone ||
          !data.contact_type ||
          !data.contact
        ) return toast.warn("Preecha os dados obrigatórios");

        if (uuid) {
          const response = await axios.put(`${URL_API}/cooperated/${uuid}`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${uuid}?step=5`);
        } else {
          const response = await axios.post(`${URL_API}/cooperated`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${response.data.uuid}?step=5`);
        }
      } else {
        navigate(`/admin/colaboradores/atualizar/${uuid}?step=4`);
      }
    } catch (e) {
      toast.error(e.response.data)
    }
  }

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Contatos</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias *
        </MDTypography>
      </MDBox>
      {
        loading ?
          <Box sx={{ width: '100%' }}>
            <LinearProgress sx={{ overflow: 'hidden' }} />
          </Box> :
          <>
            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="Celular"
                name="phone"
                value={cooperated.phone}
                mask="phoneBR"
                placeholder="Celular"
                onChange={setInput}
                required
              />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={contactTypeString(contactType ?? cooperated.contact_type)}
                    onChange={(_, newValue) => {
                      setContactType(newValue);
                    }}
                    inputValue={inputValueContactType}
                    onInputChange={(_, newInputValue) => {
                      setInputValueContactType(newInputValue);
                    }}
                    options={optionsContact}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Forma de contato"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Contato"
                    name="contact"
                    value={cooperated.contact}
                    placeholder="Contato"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
            </MDBox>

            <MDBox
              mt={2}
              width="100%"
              display="flex"
              justifyContent="space-between"
            >
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => {
                  if (user?.profile !== 99) {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=3`)
                  } else {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=2`)
                  }
                }}
              >
                voltar
              </MDButton>
              <MDButton
                type="submit"
                variant="gradient"
                color="dark"
                onClick={handleNext}
              >
                próximo
              </MDButton>
            </MDBox>
          </>
      }
    </MDBox>
  );
}

// typechecking props for CooperatedContactsFourth
CooperatedContactsFourth.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
